import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from "@angular/core";
import {FormArray, FormGroup} from "@angular/forms";
import {
  JaarrapportageEntity, ClientEntity, TrialBalanceItem, Jaarrekening, Jaarrapportage, BokkzJrLogic
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { combineLatest, distinctUntilChanged, Observable, ReplaySubject, Subject, takeUntil } from "rxjs";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SpecTrialbalanceComponent } from '../spec-trialbalance/spec-trialbalance.component';
import { SpecFormattedexplanationComponent } from '../spec-formattedexplanation/spec-formattedexplanation.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-financiele-baten-lasten',
  templateUrl: './spec-financiele-baten-lasten.component.html',
  imports: [
    SharedUiButtonModule,
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    SpecTrialbalanceComponent,
    SpecFormattedexplanationComponent,
    CommonModule
  ],
  styleUrls: ['./spec-financiele-baten-lasten.component.scss']
})
export class SpecFinancieleBatenLasten implements OnInit, OnChanges, OnDestroy {

  @Input() public id!: string;
  @Input() selectedTabObservable!: Observable<number>;
  private selectedTabSubject = new ReplaySubject<number>(1);
  showCustomControls = true;
  private destroy$ = new Subject<void>();
  public selectedTab = 0;
  public index = 0;
  public dialogVisible = false;
  public client = {} as ClientEntity;
  public jrEntity = {} as JaarrapportageEntity;
  public isRechtspersoon = false;

  public financialIncomeExpensesFg = {} as FormGroup;
  public incomeFromInvestmentsInParticipatingInterestsNotValuedAtNetAssetValueFg = {} as FormGroup;
  public incomeReceivablesNoncurrentSecuritiesFg = {} as FormGroup; //wijkt af, want komt uit andere class
  public interestIncomeRelatedIncomeFg = {} as FormGroup;
  public amortisationSharePremiumDiscountsFg = {} as FormGroup;
  public favourableDifferenceReceivedAmountPrincipalAmountFg = {} as FormGroup;
  public unfavourableDifferenceReceivedAmountPrincipalAmountFg = {} as FormGroup;

  public changesValueFinancialAssetsSecuritiesFg = {} as FormGroup; //wijkt af, want komt uit andere class en is telling van lagere uitsplisting
  public impairmentSecuritiesRecordedInIncomeStatementFg = {} as FormGroup; //wijkt af, want komt uit andere class en is lagere uitsplisting
  public impairmentSecuritiesReversalRecordedInIncomeStatementFg = {} as FormGroup; //wijkt af, want komt uit andere class en is lagere uitsplisting
  public impairmentFinancialAssetsRecordedInIncomeStatementFg = {} as FormGroup; //wijkt af, want komt uit andere class en is lagere uitsplisting
  public impairmentFinancialAssetsReversalRecordedInIncomeStatementFg = {} as FormGroup; //wijkt af, want komt uit andere class en is lagere uitsplisting

  public changesValueParticipatingInterestsNotValuedAtNetAssetValueFg = {} as FormGroup;
  public positiveRevaluationsOfPuttableFinancialInstrumentsFg = {} as FormGroup;
  public negativeRevaluationsOfPuttableFinancialInstrumentsFg = {} as FormGroup;
  public interestExpensesRelatedExpensesFg = {} as FormGroup;
  public redemptionPremiumsFg = {} as FormGroup;
  public emissionCostsFg = {} as FormGroup;
  public earlyRedemptionCostsFg = {} as FormGroup;
  public additionalCostsFinancingFg = {} as FormGroup;
  public currencyDifferencesLoansConsideredAsCorrectionInterestChargesDueFg = {} as FormGroup;
  public interestExpensesIncludedLeaseTermFinancialLeasingFg = {} as FormGroup;
  public foreignCurrencyExchangeRateResultsFg = {} as FormGroup;

  public financialIncomeExpensesDisclosureFg = {} as FormGroup;
  public incomeFromInvestmentsInParticipatingInterestsNotValuedAtNetAssetValueDisclosureFg = {} as FormGroup;
  public changesValueParticipatingInterestsNotValuedAtNetAssetValueDisclosureFg = {} as FormGroup;
  public interestIncomeRelatedIncomeDisclosureFg = {} as FormGroup;
  public interestExpensesRelatedExpensesDisclosureFg = {} as FormGroup;
  public foreignCurrencyExchangeRateResultsDisclosureFg = {} as FormGroup;
  public interestExpensesInterestCapitalisedDuringPeriodDisclosureFg = {} as FormGroup;

  public incomeReceivablesNoncurrentSecuritiesDisclosureFg = {} as FormGroup;
  public changesValueFinancialAssetsSecuritiesDisclosureFg = {} as FormGroup;
  public impairmentSecuritiesDisclosureFg = {} as FormGroup;
  public impairmentFinancialAssetsDisclosureFg = {} as FormGroup;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  public showDialog(input: number) {
    this.index = input
    this.dialogVisible = true;
  }

  constructor(
    public algDataService: BokkzAlgDataService,
    private cdRef: ChangeDetectorRef,
    private jrLogicService: BokkzJrLogic,
    public jrDataService: BokkzJrDataService) {
    this.createFormGroups();
  }

  ngOnInit(): void {
    if (this.selectedTabObservable) {
      this.selectedTabObservable
        .pipe(takeUntil(this.destroy$))
        .subscribe(tab => {
          this.selectedTabSubject.next(tab);
        });
    }

    combineLatest([
      this.selectedTabSubject.pipe(distinctUntilChanged()),
      this.jrDataService.jaarrapportageEntity
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([tab, jrEntity]) => {
        this.selectedTab = tab;
        this.jrEntity = jrEntity;
        this.patchData(jrEntity);
      });

    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedTabObservable']) {
      this.selectedTabObservable = changes['selectedTabObservable'].currentValue;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public createFormGroups() {
    this.financialIncomeExpensesFg = this.jrDataService.createFormGroupMonetaryNoDecimalsPeriodValues()
    this.incomeFromInvestmentsInParticipatingInterestsNotValuedAtNetAssetValueFg = this.jrDataService.createFormGroupBalanceItem();
    this.incomeReceivablesNoncurrentSecuritiesFg = this.jrDataService.createFormGroupBalanceItem(); //wijkt af, want komt uit andere class
    this.interestIncomeRelatedIncomeFg = this.jrDataService.createFormGroupBalanceItem();
    this.amortisationSharePremiumDiscountsFg = this.jrDataService.createFormGroupBalanceItem();
    this.favourableDifferenceReceivedAmountPrincipalAmountFg = this.jrDataService.createFormGroupBalanceItem();
    this.unfavourableDifferenceReceivedAmountPrincipalAmountFg = this.jrDataService.createFormGroupBalanceItem();

    this.changesValueFinancialAssetsSecuritiesFg = this.jrDataService.createFormGroupMonetaryNoDecimalsPeriodValues(); //wijkt af, want komt uit andere class en is telling van lagere uitsplisting
    this.impairmentSecuritiesRecordedInIncomeStatementFg = this.jrDataService.createFormGroupBalanceItem();
    this.impairmentSecuritiesReversalRecordedInIncomeStatementFg = this.jrDataService.createFormGroupBalanceItem();
    this.impairmentFinancialAssetsRecordedInIncomeStatementFg = this.jrDataService.createFormGroupBalanceItem();
    this.impairmentFinancialAssetsReversalRecordedInIncomeStatementFg = this.jrDataService.createFormGroupBalanceItem();

    this.changesValueParticipatingInterestsNotValuedAtNetAssetValueFg = this.jrDataService.createFormGroupBalanceItem();
    this.positiveRevaluationsOfPuttableFinancialInstrumentsFg = this.jrDataService.createFormGroupBalanceItem();
    this.negativeRevaluationsOfPuttableFinancialInstrumentsFg = this.jrDataService.createFormGroupBalanceItem();
    this.interestExpensesRelatedExpensesFg = this.jrDataService.createFormGroupBalanceItem();
    this.redemptionPremiumsFg = this.jrDataService.createFormGroupBalanceItem();
    this.emissionCostsFg = this.jrDataService.createFormGroupBalanceItem();
    this.earlyRedemptionCostsFg = this.jrDataService.createFormGroupBalanceItem();
    this.additionalCostsFinancingFg = this.jrDataService.createFormGroupBalanceItem();
    this.currencyDifferencesLoansConsideredAsCorrectionInterestChargesDueFg = this.jrDataService.createFormGroupBalanceItem();
    this.interestExpensesIncludedLeaseTermFinancialLeasingFg = this.jrDataService.createFormGroupBalanceItem();
    this.foreignCurrencyExchangeRateResultsFg = this.jrDataService.createFormGroupBalanceItem();

    this.financialIncomeExpensesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.incomeFromInvestmentsInParticipatingInterestsNotValuedAtNetAssetValueDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.changesValueParticipatingInterestsNotValuedAtNetAssetValueDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.interestIncomeRelatedIncomeDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.interestExpensesRelatedExpensesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.foreignCurrencyExchangeRateResultsDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.interestExpensesInterestCapitalisedDuringPeriodDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();

    this.incomeReceivablesNoncurrentSecuritiesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.changesValueFinancialAssetsSecuritiesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.impairmentSecuritiesDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();
    this.impairmentFinancialAssetsDisclosureFg = this.jrDataService.createFormGroupFormattedExplanation();

  }

  private patchData(value: JaarrapportageEntity) {
    const financieleBatenLasten = value.rapportage?.jaarrekeningen?.at(0)?.winstEnVerliesrekening?.financieleBatenLasten;

    if (financieleBatenLasten) {
      this.financialIncomeExpensesFg.reset();

      if (financieleBatenLasten.financialIncomeExpenses) {
        this.financialIncomeExpensesFg.patchValue(financieleBatenLasten.financialIncomeExpenses, {emitEvent: false})
      }

      const uitsplitsing = financieleBatenLasten.financieleBatenLastenUitsplitsing;
      const tekstueel = financieleBatenLasten.financieleBatenLastenTekstueel;

      if (uitsplitsing) {
        if (uitsplitsing.incomeFromInvestmentsInParticipatingInterestsNotValuedAtNetAssetValue) {
          const subItem = uitsplitsing.incomeFromInvestmentsInParticipatingInterestsNotValuedAtNetAssetValue;
          this.incomeFromInvestmentsInParticipatingInterestsNotValuedAtNetAssetValueFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.incomeFromInvestmentsInParticipatingInterestsNotValuedAtNetAssetValueFg.get('trialBalanceItems') as FormArray)
        }
        const opbrengstenAndereEffectenEnVorderingenVa = uitsplitsing.opbrengstenAndereEffectenEnVorderingenVa;
        if (opbrengstenAndereEffectenEnVorderingenVa) {
          if (opbrengstenAndereEffectenEnVorderingenVa?.incomeReceivablesNoncurrentSecurities) {
            const subItem = opbrengstenAndereEffectenEnVorderingenVa.incomeReceivablesNoncurrentSecurities;
            this.incomeReceivablesNoncurrentSecuritiesFg.patchValue(subItem)
            this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.incomeReceivablesNoncurrentSecuritiesFg.get('trialBalanceItems') as FormArray)
          }
          const opbrengstenAndereEffectenEnVorderingenVaTekstueel = opbrengstenAndereEffectenEnVorderingenVa?.opbrengstenAndereEffectenEnVorderingenVaTekstueel;
          if (opbrengstenAndereEffectenEnVorderingenVaTekstueel) {
            if (opbrengstenAndereEffectenEnVorderingenVaTekstueel.incomeReceivablesNoncurrentSecuritiesDisclosure) {
              this.incomeReceivablesNoncurrentSecuritiesDisclosureFg.patchValue(opbrengstenAndereEffectenEnVorderingenVaTekstueel.incomeReceivablesNoncurrentSecuritiesDisclosure);
            }
          }
        }
        if (uitsplitsing.interestIncomeRelatedIncome) {
          const subItem = uitsplitsing.interestIncomeRelatedIncome;
          this.interestIncomeRelatedIncomeFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.interestIncomeRelatedIncomeFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.amortisationSharePremiumDiscounts) {
          const subItem = uitsplitsing.amortisationSharePremiumDiscounts;
          this.amortisationSharePremiumDiscountsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.amortisationSharePremiumDiscountsFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.favourableDifferenceReceivedAmountPrincipalAmount) {
          const subItem = uitsplitsing.favourableDifferenceReceivedAmountPrincipalAmount;
          this.favourableDifferenceReceivedAmountPrincipalAmountFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.favourableDifferenceReceivedAmountPrincipalAmountFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.unfavourableDifferenceReceivedAmountPrincipalAmount) {
          const subItem = uitsplitsing.unfavourableDifferenceReceivedAmountPrincipalAmount;
          this.unfavourableDifferenceReceivedAmountPrincipalAmountFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.unfavourableDifferenceReceivedAmountPrincipalAmountFg.get('trialBalanceItems') as FormArray)
        }

        //wijkt af, want komt uit andere class en is telling met lagere uitsplisting
        const waardeveranderingenFvaEnVanEffecten = uitsplitsing.waardeveranderingenFvaEnVanEffecten;
        if (waardeveranderingenFvaEnVanEffecten) {
          this.changesValueFinancialAssetsSecuritiesFg.reset();

          if (waardeveranderingenFvaEnVanEffecten?.changesValueFinancialAssetsSecurities) {
            this.changesValueFinancialAssetsSecuritiesFg.patchValue(waardeveranderingenFvaEnVanEffecten.changesValueFinancialAssetsSecurities, {emitEvent: false})
          }

          const waardeveranderingenFvaEnVanEffectenUitsplitsing = waardeveranderingenFvaEnVanEffecten?.waardeveranderingenFvaEnVanEffectenUitsplitsing;
          const waardeveranderingenFvaEnVanEffectenTekstueel = waardeveranderingenFvaEnVanEffecten?.waardeveranderingenFvaEnVanEffectenTekstueel;

          if (waardeveranderingenFvaEnVanEffectenUitsplitsing) {
            if (waardeveranderingenFvaEnVanEffectenUitsplitsing.impairmentSecuritiesRecordedInIncomeStatement) {
              const subItem = waardeveranderingenFvaEnVanEffectenUitsplitsing.impairmentSecuritiesRecordedInIncomeStatement;
              this.impairmentSecuritiesRecordedInIncomeStatementFg.patchValue(subItem)
              this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.impairmentSecuritiesRecordedInIncomeStatementFg.get('trialBalanceItems') as FormArray)
            }
            if (waardeveranderingenFvaEnVanEffectenUitsplitsing.impairmentSecuritiesReversalRecordedInIncomeStatement) {
              const subItem = waardeveranderingenFvaEnVanEffectenUitsplitsing.impairmentSecuritiesReversalRecordedInIncomeStatement;
              this.impairmentSecuritiesReversalRecordedInIncomeStatementFg.patchValue(subItem)
              this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.impairmentSecuritiesReversalRecordedInIncomeStatementFg.get('trialBalanceItems') as FormArray)
            }
            if (waardeveranderingenFvaEnVanEffectenUitsplitsing.impairmentFinancialAssetsRecordedInIncomeStatement) {
              const subItem = waardeveranderingenFvaEnVanEffectenUitsplitsing.impairmentFinancialAssetsRecordedInIncomeStatement;
              this.impairmentFinancialAssetsRecordedInIncomeStatementFg.patchValue(subItem)
              this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.impairmentFinancialAssetsRecordedInIncomeStatementFg.get('trialBalanceItems') as FormArray)
            }
            if (waardeveranderingenFvaEnVanEffectenUitsplitsing.impairmentFinancialAssetsReversalRecordedInIncomeStatement) {
              const subItem = waardeveranderingenFvaEnVanEffectenUitsplitsing.impairmentFinancialAssetsReversalRecordedInIncomeStatement;
              this.impairmentFinancialAssetsReversalRecordedInIncomeStatementFg.patchValue(subItem)
              this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.impairmentFinancialAssetsReversalRecordedInIncomeStatementFg.get('trialBalanceItems') as FormArray)
            }
          }
          if (waardeveranderingenFvaEnVanEffectenTekstueel) {
            if (waardeveranderingenFvaEnVanEffectenTekstueel.changesValueFinancialAssetsSecuritiesDisclosure) {
              this.changesValueFinancialAssetsSecuritiesDisclosureFg.patchValue(waardeveranderingenFvaEnVanEffectenTekstueel.changesValueFinancialAssetsSecuritiesDisclosure);
            }
            if (waardeveranderingenFvaEnVanEffectenTekstueel.impairmentSecuritiesDisclosure) {
              this.impairmentSecuritiesDisclosureFg.patchValue(waardeveranderingenFvaEnVanEffectenTekstueel.impairmentSecuritiesDisclosure);
            }
            if (waardeveranderingenFvaEnVanEffectenTekstueel.impairmentFinancialAssetsDisclosure) {
              this.impairmentFinancialAssetsDisclosureFg.patchValue(waardeveranderingenFvaEnVanEffectenTekstueel.impairmentFinancialAssetsDisclosure);
            }
          }
        }

        if (uitsplitsing.changesValueParticipatingInterestsNotValuedAtNetAssetValue) {
          const subItem = uitsplitsing.changesValueParticipatingInterestsNotValuedAtNetAssetValue;
          this.changesValueParticipatingInterestsNotValuedAtNetAssetValueFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.changesValueParticipatingInterestsNotValuedAtNetAssetValueFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.positiveRevaluationsOfPuttableFinancialInstruments) {
          const subItem = uitsplitsing.positiveRevaluationsOfPuttableFinancialInstruments;
          this.positiveRevaluationsOfPuttableFinancialInstrumentsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.positiveRevaluationsOfPuttableFinancialInstrumentsFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.negativeRevaluationsOfPuttableFinancialInstruments) {
          const subItem = uitsplitsing.negativeRevaluationsOfPuttableFinancialInstruments;
          this.negativeRevaluationsOfPuttableFinancialInstrumentsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.negativeRevaluationsOfPuttableFinancialInstrumentsFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.interestExpensesRelatedExpenses) {
          const subItem = uitsplitsing.interestExpensesRelatedExpenses;
          this.interestExpensesRelatedExpensesFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.interestExpensesRelatedExpensesFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.redemptionPremiums) {
          const subItem = uitsplitsing.redemptionPremiums;
          this.redemptionPremiumsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.redemptionPremiumsFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.emissionCosts) {
          const subItem = uitsplitsing.emissionCosts;
          this.emissionCostsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.emissionCostsFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.earlyRedemptionCosts) {
          const subItem = uitsplitsing.earlyRedemptionCosts;
          this.earlyRedemptionCostsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.earlyRedemptionCostsFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.additionalCostsFinancing) {
          const subItem = uitsplitsing.additionalCostsFinancing;
          this.additionalCostsFinancingFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.additionalCostsFinancingFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.currencyDifferencesLoansConsideredAsCorrectionInterestChargesDue) {
          const subItem = uitsplitsing.currencyDifferencesLoansConsideredAsCorrectionInterestChargesDue;
          this.currencyDifferencesLoansConsideredAsCorrectionInterestChargesDueFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.currencyDifferencesLoansConsideredAsCorrectionInterestChargesDueFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.interestExpensesIncludedLeaseTermFinancialLeasing) {
          const subItem = uitsplitsing.interestExpensesIncludedLeaseTermFinancialLeasing;
          this.interestExpensesIncludedLeaseTermFinancialLeasingFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem?.trialBalanceItems!, this.interestExpensesIncludedLeaseTermFinancialLeasingFg.get('trialBalanceItems') as FormArray)
        }
        if (uitsplitsing.foreignCurrencyExchangeRateResults) {
          const subItem = uitsplitsing.foreignCurrencyExchangeRateResults;
          this.foreignCurrencyExchangeRateResultsFg.patchValue(subItem)
          this.updateTrialBalanceItems(subItem.trialBalanceItems!, this.foreignCurrencyExchangeRateResultsFg.get('trialBalanceItems') as FormArray)
        }
      }
      if (tekstueel) {
        if (tekstueel.financialIncomeExpensesDisclosure) {
          this.financialIncomeExpensesDisclosureFg.patchValue(tekstueel.financialIncomeExpensesDisclosure);
        }
        if (tekstueel.incomeFromInvestmentsInParticipatingInterestsNotValuedAtNetAssetValueDisclosure) {
          this.incomeFromInvestmentsInParticipatingInterestsNotValuedAtNetAssetValueDisclosureFg.patchValue(tekstueel.incomeFromInvestmentsInParticipatingInterestsNotValuedAtNetAssetValueDisclosure);
        }
        if (tekstueel.changesValueParticipatingInterestsNotValuedAtNetAssetValueDisclosure) {
          this.changesValueParticipatingInterestsNotValuedAtNetAssetValueDisclosureFg.patchValue(tekstueel.changesValueParticipatingInterestsNotValuedAtNetAssetValueDisclosure);
        }
        if (tekstueel.interestIncomeRelatedIncomeDisclosure) {
          this.interestIncomeRelatedIncomeDisclosureFg.patchValue(tekstueel.interestIncomeRelatedIncomeDisclosure);
        }
        if (tekstueel.interestExpensesRelatedExpensesDisclosure) {
          this.interestExpensesRelatedExpensesDisclosureFg.patchValue(tekstueel.interestExpensesRelatedExpensesDisclosure);
        }
        if (tekstueel.foreignCurrencyExchangeRateResultsDisclosure) {
          this.foreignCurrencyExchangeRateResultsDisclosureFg.patchValue(tekstueel.foreignCurrencyExchangeRateResultsDisclosure);
        }
        if (tekstueel.interestExpensesInterestCapitalisedDuringPeriodDisclosure) {
          this.interestExpensesInterestCapitalisedDuringPeriodDisclosureFg.patchValue(tekstueel.interestExpensesInterestCapitalisedDuringPeriodDisclosure);
        }
      }
    }
  }

  updateTrialBalanceItems(lijst?: TrialBalanceItem[], formArray?: FormArray) {
    if (lijst && formArray) {
      for (let i = 0; i < lijst.length; i++) {
        if (i < formArray.length) {
          const control = formArray.at(i) as FormGroup;
          control.patchValue(lijst[i]);
        } else {
          const formGroup = this.jrDataService.createFormGroupTrialBalanceItem(lijst[i])
          formArray.push(formGroup);
        }
      }
    }
  }

  public saveForm(): void {
    this.showCustomControls = false;
    this.cdRef.detectChanges();
    setTimeout(() => {
      this.showCustomControls = true;
      this.cdRef.detectChanges();
    });
    this.financialIncomeExpensesFg.updateValueAndValidity();
    this.incomeFromInvestmentsInParticipatingInterestsNotValuedAtNetAssetValueFg.updateValueAndValidity();
    this.incomeReceivablesNoncurrentSecuritiesFg.updateValueAndValidity(); //wijkt af, want komt uit andere class
    this.interestIncomeRelatedIncomeFg.updateValueAndValidity();
    this.amortisationSharePremiumDiscountsFg.updateValueAndValidity();
    this.favourableDifferenceReceivedAmountPrincipalAmountFg.updateValueAndValidity();
    this.unfavourableDifferenceReceivedAmountPrincipalAmountFg.updateValueAndValidity();

    this.changesValueFinancialAssetsSecuritiesFg.updateValueAndValidity(); //wijkt af, want komt uit andere class en is telling van lagere uitsplisting
    this.impairmentSecuritiesRecordedInIncomeStatementFg.updateValueAndValidity();
    this.impairmentSecuritiesReversalRecordedInIncomeStatementFg.updateValueAndValidity();
    this.impairmentFinancialAssetsRecordedInIncomeStatementFg.updateValueAndValidity();
    this.impairmentFinancialAssetsReversalRecordedInIncomeStatementFg.updateValueAndValidity();

    this.changesValueParticipatingInterestsNotValuedAtNetAssetValueFg.updateValueAndValidity();
    this.positiveRevaluationsOfPuttableFinancialInstrumentsFg.updateValueAndValidity();
    this.negativeRevaluationsOfPuttableFinancialInstrumentsFg.updateValueAndValidity();
    this.interestExpensesRelatedExpensesFg.updateValueAndValidity();
    this.redemptionPremiumsFg.updateValueAndValidity();
    this.emissionCostsFg.updateValueAndValidity();
    this.earlyRedemptionCostsFg.updateValueAndValidity();
    this.additionalCostsFinancingFg.updateValueAndValidity();
    this.currencyDifferencesLoansConsideredAsCorrectionInterestChargesDueFg.updateValueAndValidity();
    this.interestExpensesIncludedLeaseTermFinancialLeasingFg.updateValueAndValidity();
    this.foreignCurrencyExchangeRateResultsFg.updateValueAndValidity();

    this.financialIncomeExpensesDisclosureFg.updateValueAndValidity();
    this.incomeFromInvestmentsInParticipatingInterestsNotValuedAtNetAssetValueDisclosureFg.updateValueAndValidity();
    this.changesValueParticipatingInterestsNotValuedAtNetAssetValueDisclosureFg.updateValueAndValidity();
    this.interestIncomeRelatedIncomeDisclosureFg.updateValueAndValidity();
    this.interestExpensesRelatedExpensesDisclosureFg.updateValueAndValidity();
    this.foreignCurrencyExchangeRateResultsDisclosureFg.updateValueAndValidity();
    this.interestExpensesInterestCapitalisedDuringPeriodDisclosureFg.updateValueAndValidity();

    this.incomeReceivablesNoncurrentSecuritiesDisclosureFg.updateValueAndValidity();
    this.changesValueFinancialAssetsSecuritiesDisclosureFg.updateValueAndValidity();
    this.impairmentSecuritiesDisclosureFg.updateValueAndValidity();
    this.impairmentFinancialAssetsDisclosureFg.updateValueAndValidity();

    if (this.jrEntity && this.jrEntity.rapportage && this.jrEntity.rapportage.jaarrekeningen) {
      this.jrEntity.rapportage.jaarrekeningen[0] = {
        ...this.jrEntity.rapportage.jaarrekeningen[0],
        winstEnVerliesrekening: {
          ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening,
          financieleBatenLasten: {
            ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.financieleBatenLasten,
            financieleBatenLastenUitsplitsing: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.financieleBatenLasten?.financieleBatenLastenUitsplitsing,
              incomeFromInvestmentsInParticipatingInterestsNotValuedAtNetAssetValue: this.incomeFromInvestmentsInParticipatingInterestsNotValuedAtNetAssetValueFg.value,
              interestIncomeRelatedIncome: this.interestIncomeRelatedIncomeFg.value,
              amortisationSharePremiumDiscounts: this.amortisationSharePremiumDiscountsFg.value,
              favourableDifferenceReceivedAmountPrincipalAmount: this.favourableDifferenceReceivedAmountPrincipalAmountFg.value,
              unfavourableDifferenceReceivedAmountPrincipalAmount: this.unfavourableDifferenceReceivedAmountPrincipalAmountFg.value,
              changesValueParticipatingInterestsNotValuedAtNetAssetValue: this.changesValueParticipatingInterestsNotValuedAtNetAssetValueFg.value,
              positiveRevaluationsOfPuttableFinancialInstruments: this.positiveRevaluationsOfPuttableFinancialInstrumentsFg.value,
              negativeRevaluationsOfPuttableFinancialInstruments: this.negativeRevaluationsOfPuttableFinancialInstrumentsFg.value,
              interestExpensesRelatedExpenses: this.interestExpensesRelatedExpensesFg.value,
              redemptionPremiums: this.redemptionPremiumsFg.value,
              emissionCosts: this.emissionCostsFg.value,
              earlyRedemptionCosts: this.earlyRedemptionCostsFg.value,
              additionalCostsFinancing: this.additionalCostsFinancingFg.value,
              currencyDifferencesLoansConsideredAsCorrectionInterestChargesDue: this.currencyDifferencesLoansConsideredAsCorrectionInterestChargesDueFg.value,
              interestExpensesIncludedLeaseTermFinancialLeasing: this.interestExpensesIncludedLeaseTermFinancialLeasingFg.value,
              foreignCurrencyExchangeRateResults: this.foreignCurrencyExchangeRateResultsFg.value,
              opbrengstenAndereEffectenEnVorderingenVa: {
                ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.financieleBatenLasten?.financieleBatenLastenUitsplitsing?.opbrengstenAndereEffectenEnVorderingenVa,
                incomeReceivablesNoncurrentSecurities: this.incomeReceivablesNoncurrentSecuritiesFg.value,
                opbrengstenAndereEffectenEnVorderingenVaTekstueel: {
                  ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.financieleBatenLasten?.financieleBatenLastenUitsplitsing?.opbrengstenAndereEffectenEnVorderingenVa?.opbrengstenAndereEffectenEnVorderingenVaTekstueel,
                  incomeReceivablesNoncurrentSecuritiesDisclosure: this.incomeReceivablesNoncurrentSecuritiesDisclosureFg.value,
                }
              },
              waardeveranderingenFvaEnVanEffecten: {
                ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.financieleBatenLasten?.financieleBatenLastenUitsplitsing?.waardeveranderingenFvaEnVanEffecten,
                waardeveranderingenFvaEnVanEffectenUitsplitsing: {
                  ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.financieleBatenLasten?.financieleBatenLastenUitsplitsing?.waardeveranderingenFvaEnVanEffecten?.waardeveranderingenFvaEnVanEffectenUitsplitsing,
                  impairmentSecuritiesRecordedInIncomeStatement: this.impairmentSecuritiesRecordedInIncomeStatementFg.value,
                  impairmentSecuritiesReversalRecordedInIncomeStatement: this.impairmentSecuritiesReversalRecordedInIncomeStatementFg.value,
                  impairmentFinancialAssetsRecordedInIncomeStatement: this.impairmentFinancialAssetsRecordedInIncomeStatementFg.value,
                  impairmentFinancialAssetsReversalRecordedInIncomeStatement: this.impairmentFinancialAssetsReversalRecordedInIncomeStatementFg.value,
                },
                waardeveranderingenFvaEnVanEffectenTekstueel: {
                  ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.financieleBatenLasten?.financieleBatenLastenUitsplitsing?.waardeveranderingenFvaEnVanEffecten?.waardeveranderingenFvaEnVanEffectenTekstueel,
                  changesValueFinancialAssetsSecuritiesDisclosure: this.changesValueFinancialAssetsSecuritiesDisclosureFg.value,
                  impairmentSecuritiesDisclosure: this.impairmentSecuritiesDisclosureFg.value,
                  impairmentFinancialAssetsDisclosure: this.impairmentFinancialAssetsDisclosureFg.value,
                }
              },
            },
            financieleBatenLastenTekstueel: {
              ...this.jrEntity.rapportage?.jaarrekeningen[0]?.winstEnVerliesrekening?.financieleBatenLasten?.financieleBatenLastenTekstueel,
              financialIncomeExpensesDisclosure: this.financialIncomeExpensesDisclosureFg.value,
              incomeFromInvestmentsInParticipatingInterestsNotValuedAtNetAssetValueDisclosure: this.incomeFromInvestmentsInParticipatingInterestsNotValuedAtNetAssetValueDisclosureFg.value,
              changesValueParticipatingInterestsNotValuedAtNetAssetValueDisclosure: this.changesValueParticipatingInterestsNotValuedAtNetAssetValueDisclosureFg.value,
              interestIncomeRelatedIncomeDisclosure: this.interestIncomeRelatedIncomeDisclosureFg.value,
              interestExpensesRelatedExpensesDisclosure: this.interestExpensesRelatedExpensesDisclosureFg.value,
              foreignCurrencyExchangeRateResultsDisclosure: this.foreignCurrencyExchangeRateResultsDisclosureFg.value,
              interestExpensesInterestCapitalisedDuringPeriodDisclosure: this.interestExpensesInterestCapitalisedDuringPeriodDisclosureFg.value,
            }
          },
        }
      } as Jaarrekening
    }

    this.jrEntity = {
      ...this.jrEntity,
      rapportage: {
        ...this.jrEntity.rapportage,
        jaarrekeningen: [this.jrEntity.rapportage?.jaarrekeningen?.at(0)]
      }
    } as Jaarrapportage
    this.jrDataService.updateEntity(this.jrEntity);
    this.jrLogicService.getCalculation(this.jrEntity)

  }
}

